export default {
  navStatus: {
    active: 'active',
    pending: 'pending',
  },
};
